import React from "react";

const Header = () => {
  return (
    <section className="top-banner">
      <div className="container">
        <center>
          <h1 className="heading">Weather App</h1>
        </center>
      </div>
    </section>
  );
};

export default Header;
